import { useState } from "react";
import { Check, ArrowRight, ShieldCheck, Coins } from "lucide-react";

const outHref = (u, m = "") => `/out?u=${encodeURIComponent(u || "")}&src=cuelinks${m ? `&m=${encodeURIComponent(m)}` : ""}`;

// Professional "Benefit Card" for finance/banking affiliate partners (credit cards, loans,
// insurance, banking). Logo shown contained; CTA routes through the tracked /out hand-off.
export const BenefitCard = ({ d }) => {
  const [logoOk, setLogoOk] = useState(true);
  const [bannerOk, setBannerOk] = useState(true);
  const initial = (d.name || d.domain || "?").trim().charAt(0).toUpperCase() || "?";
  const banner = d.banner && bannerOk ? d.banner : null;
  const logo = !banner && d.logo && logoOk ? d.logo : null;
  return (
    <div data-testid={`finance-card-${d.id}`} className="flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition hover:-translate-y-0.5 hover:shadow-lg">
      <div className="flex items-center gap-3 border-b border-slate-100 p-4">
        <div className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-slate-50 p-2 ring-1 ring-slate-200">
          {banner ? <img src={banner} alt={d.name} className="max-h-full max-w-full object-contain" onError={() => setBannerOk(false)} loading="lazy" />
            : logo ? <img src={logo} alt={d.name} className="max-h-full max-w-full object-contain" onError={() => setLogoOk(false)} loading="lazy" />
            : <span data-testid={`finance-initial-${d.id}`} className="text-xl font-bold text-indigo-500">{initial}</span>}
        </div>
        <div className="min-w-0">
          <p className="truncate text-sm font-bold text-slate-900">{d.name}</p>
          <span className="mt-0.5 inline-block rounded-full bg-indigo-50 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-indigo-600">{d.subtype_label}</span>
        </div>
        {d.indian_partner && <span className="ml-auto inline-flex shrink-0 items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-700"><ShieldCheck className="h-3 w-3" />India</span>}
      </div>
      <div className="flex flex-1 flex-col gap-3 p-4">
        {d.reason && <p className="rounded-lg bg-amber-50 px-3 py-2 text-xs font-medium text-amber-800" data-testid={`finance-reason-${d.id}`}>{d.reason}</p>}
        {d.est_cashback && <p className="flex items-start gap-1.5 rounded-lg bg-emerald-50 px-3 py-2 text-xs font-semibold text-emerald-700" data-testid={`finance-cashback-${d.id}`}><Coins className="mt-0.5 h-3.5 w-3.5 shrink-0" />{d.est_cashback.note}</p>}
        <ul className="space-y-1.5">
          {(d.benefits || []).map((b, i) => <li key={i} className="flex items-start gap-2 text-sm text-slate-600"><Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" />{b}</li>)}
        </ul>
        <div className="mt-auto pt-1 text-xs text-slate-500">Joining fee: <span className="font-semibold text-slate-700">{d.joining_fee}</span> · exact fees & eligibility on partner site</div>
        <a href={outHref(d.url, d.name)} target="_blank" rel="nofollow sponsored noopener noreferrer" data-testid={`finance-apply-${d.id}`} className="inline-flex items-center justify-center gap-1.5 rounded-full brand-gradient-bg px-4 py-2.5 text-sm font-semibold text-white transition hover:opacity-90">
          {d.cta || "Apply Now"} <ArrowRight className="h-4 w-4" />
        </a>
      </div>
    </div>
  );
};

export default BenefitCard;
